<template>
    <div>
        <el-form label-position="top" class="u-mb-10" v-if="exibeSelectInstituicao">
            <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="24">
                    <el-form-item>
                        <el-select @change="changeInstituicao" v-model="filtro.instituicao.id" filterable placeholder="Pesquisar Instituição">
                            <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <el-row class="u-mt-10 u-mb-20">
            <el-col :xs="24" :sm="24" :md="24">
                <el-input v-model="filtro['usuario_id']" placeholder="ID do usuário" @keyup.native.enter="loading"></el-input>
            </el-col>
            
        </el-row>

        <el-row :gutter="10" class="u-mb-10">
            <el-col :xs="24" :sm="8" :md="8">
                <el-select v-model="filtro['status']" placeholder="Status" clearable @change="loading" style="width: 100%;">
                    <el-option label="AGUARDANDO" value="aguardando"></el-option>
                    <el-option label="ATENDIDA" value="atendida"></el-option>
                    <el-option label="EXPIRADA" value="expirada"></el-option>
                    <el-option label="CANCELADA" value="cancelada"></el-option>
                </el-select>
            </el-col>
            <el-col :xs="24" :sm="8" :md="8">
                <el-select v-model="filtro['usuario_tipo']" placeholder="Tipo do usuário" clearable @change="loading" style="width: 100%;">
                    <el-option label="ALUNO" value="aluno"></el-option>
                    <el-option label="SERVIDOR" value="servidor"></el-option>
                    <el-option label="FUNCIONÁRIO" value="funcionario"></el-option>
                </el-select>
            </el-col>
            <el-col :xs="24" :sm="8" :md="8" class="u-text-right">
                <el-button @click="resetFiltro" plain>LIMPAR FILTROS</el-button>
                <el-button type="primary" @click="abrirCadastro">NOVA RESERVA</el-button>
            </el-col>
        </el-row>

        <div class="container-table">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th class="hidden-mobile" style="width: 70px;">cod</th>
                        <th>Livro</th>
                        <th class="hidden-mobile">Leitor</th>
                        <th class="hidden-mobile u-text-center" style="width: 130px;">Reservada em</th>
                        <th class="hidden-mobile u-text-center" style="width: 130px;">Validade</th>
                        <th class="hidden-mobile u-text-center" style="width: 120px;">Status</th>
                        <th style="width: 200px;" class="u-text-center">Ação</th>
                    </tr>
                </thead>
                <tbody v-if="statusList">
                    <tr v-for="item in items" :key="item.id">
                        <td class="hidden-mobile">{{ item.id }}</td>
                        <td>{{ (item.livro && item.livro.titulo) ? item.livro.titulo : '-' }}</td>
                        <td class="hidden-mobile">#{{ item.usuario_id }} ({{ (item.usuario_tipo || '').toUpperCase() }})</td>
                        <td class="hidden-mobile u-text-center">{{ formatData(item.data_reserva) }}</td>
                        <td class="hidden-mobile u-text-center">{{ formatData(item.data_validade) }}</td>
                        <td class="hidden-mobile u-text-center">{{ (item.status || '').toUpperCase() }}</td>
                        <td class="u-text-center acao">
                            <el-button :disabled="item.status !== 'aguardando'" @click="abrirAtender(item)" title="Atender / criar empréstimo" type="success" icon="el-icon-check" size="mini" plain></el-button>
                            <el-button :disabled="item.status !== 'aguardando'" @click="cancelar(item.id)" title="Cancelar reserva" type="warning" icon="el-icon-close" size="mini" plain></el-button>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div v-if="!statusList" class="u-text-center u-mt-25">
                <img src="/public/img/loading-bar.gif" />
            </div>
            <el-row :gutter="10" v-if="statusList">
                <el-col :xs="24" :sm="12" :md="12">
                    <div class="u-text-left u-mt-10">
                        Mostrando {{ paginate.from }} até {{ paginate.to }} de {{ paginate.qtdItens }} registros encontrados.
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="12" v-if="paginate.qtdItens > 30">
                    <div class="u-text-right">
                        <el-pagination :current-page='paginate.page' class="u-mt-10" :total="paginate.qtdItens" @current-change="getPagePagination" :page-size="30" background layout="prev, pager, next" small></el-pagination>
                    </div>
                </el-col>
            </el-row>
        </div>

        <el-dialog title="Atender reserva" :visible.sync="dialogAtenderVisible" width="500px" :close-on-click-modal="false">
            <div v-if="reservaSelected">
                <p><strong>Livro:</strong> {{ reservaSelected.livro && reservaSelected.livro.titulo }}</p>
                <p><strong>Leitor:</strong> #{{ reservaSelected.usuario_id }} ({{ (reservaSelected.usuario_tipo || '').toUpperCase() }})</p>
            </div>
            <el-form @submit.native.prevent="confirmarAtender" :model="formAtender" ref="formAtender" label-position="top">
                <el-form-item label="Exemplar disponível" prop="exemplar_id" :rules="[$requiredChange]">
                    <el-select v-model="formAtender.exemplar_id" placeholder="Pesquisar exemplar disponível..." filterable remote :remote-method="buscarExemplares" :loading="loadingExemplares" style="width: 100%;">
                        <el-option v-for="ex in exemplares" :key="ex.id" :label="formatExemplar(ex)" :value="ex.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Data prevista de devolução" prop="data_prevista_devolucao" :rules="[$requiredChange]">
                    <el-date-picker v-model="formAtender.data_prevista_devolucao" type="date" placeholder="Selecionar data" format="dd/MM/yyyy" value-format="yyyy-MM-dd" style="width:100%"></el-date-picker>
                </el-form-item>
                <el-form-item class="u-text-right">
                    <el-button @click="dialogAtenderVisible = false" plain>Cancelar</el-button>
                    <el-button type="primary" id="btn-atender" native-type="submit">CONFIRMAR ATENDIMENTO</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data: () => ({
        statusList: false,
        filtro: {
            usuario_tipo: '',
            usuario_id: '',
            status: '',
            instituicao_id: '',
            instituicao: { id: '', nome: '' }
        },
        paginate: { page: 1, qtdItens: null, from: '', to: '' },
        items: [],
        dialogAtenderVisible: false,
        reservaSelected: null,
        formAtender: {
            exemplar_id: '',
            data_prevista_devolucao: ''
        },
        exemplares: [],
        loadingExemplares: false
    }),
    computed: {
        exibeSelectInstituicao(){
            const t = Number(this.$store.state.user.tipo);
            return (t > 3 && t <= 8) || t === 10;
        }
    },
    mounted () {
        if(this.$store.state.config.instituicao){
            this.filtro.instituicao = { id: this.$store.state.config.instituicao.id, nome: this.$store.state.config.instituicao.nome };
        }
        this.loading();
    },
    methods: {
        abrirCadastro(){
            if(!this.$store.state.config.instituicao || !this.$store.state.config.instituicao.id){
                window.eventBus.$emit('alert', {msg: 'Selecione uma instituição antes de cadastrar uma reserva.', type: 'warning'});
                return;
            }
            this.$router.push({
                path: '/admin/biblioteca/reserva/cadastro',
                query: { instituicao_id: this.$store.state.config.instituicao.id }
            });
        },
        async changeInstituicao(){
            if(this.exibeSelectInstituicao){
                await this.$store.dispatch('setInstituicao', this.filtro.instituicao.id);
            }
            this.paginate.page = 1;
            this.loading();
        },
        loading(){
            this.statusList = false;
            this.items = [];
            this.filtro.instituicao_id = this.$store.state.config.instituicao ? this.$store.state.config.instituicao.id : '';

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/biblioteca/reserva/getAllPaginate?page=` + this.paginate.page, this.filtro, this.$store.getters.getHeaderAuth).then(response => {
                this.items = response.data.data;
                this.paginate.qtdItens = response.data.total;
                this.paginate.from = response.data.from;
                this.paginate.to = response.data.to;
                this.statusList = true;
            }).catch((error) => { this.$store.commit('throwException', error); });
        },
        cancelar(id){
            this.$msgbox.confirm('Cancelar esta reserva?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }).then(() => {
                window.eventBus.$emit('loading', true);
                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/biblioteca/reserva/cancelar/` + id, {}, this.$store.getters.getHeaderAuth).then((response) => {
                    window.eventBus.$emit('loading', false);
                    if(response.data && response.data.erro){
                        const msg = typeof response.data.erro === 'string' ? response.data.erro : (response.data.erro.text || 'Não foi possível cancelar a reserva.');
                        window.eventBus.$emit('alert', {msg, type: 'warning'});
                        return;
                    }
                    window.eventBus.$emit('alert', {msg: 'Reserva cancelada.', type: 'success'});
                    this.loading();
                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });
            }).catch(()=>{});
        },
        abrirAtender(reserva){
            this.reservaSelected = reserva;
            this.formAtender = { exemplar_id: '', data_prevista_devolucao: '' };
            this.exemplares = [];
            this.dialogAtenderVisible = true;
            // já busca os exemplares disponíveis do livro
            this.preCarregarExemplaresDoLivro(reserva.livro_id);
        },
        preCarregarExemplaresDoLivro(livroId){
            this.loadingExemplares = true;
            const instituicaoId = this.$store.state.config.instituicao ? this.$store.state.config.instituicao.id : '';
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/biblioteca/exemplar/getAllPaginate?page=1`, { livro_id: livroId, status: 'disponivel', instituicao_id: instituicaoId }, this.$store.getters.getHeaderAuth).then(response => {
                this.exemplares = (response.data.data || []);
                this.loadingExemplares = false;
            }).catch((error) => { this.loadingExemplares = false; this.$store.commit('throwException', error); });
        },
        buscarExemplares(query){
            if(!query || query.length < 2){ return; }
            this.loadingExemplares = true;
            const instituicaoId = this.$store.state.config.instituicao ? this.$store.state.config.instituicao.id : '';
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/biblioteca/exemplar/searchByNome`, { query, instituicao_id: instituicaoId }, this.$store.getters.getHeaderAuth).then(response => {
                const data = response.data || [];
                const livroId = this.reservaSelected ? this.reservaSelected.livro_id : null;
                this.exemplares = Array.isArray(data) ? data.filter(x => x && x.status === 'disponivel' && (!livroId || x.livro_id === livroId)) : [];
                this.loadingExemplares = false;
            }).catch((error) => { this.loadingExemplares = false; this.$store.commit('throwException', error); });
        },
        formatExemplar(ex){
            let label = `#${ex.id} - ${ex.codigo}`;
            if(ex.livro && ex.livro.titulo){ label += ` - ${ex.livro.titulo}`; }
            return label;
        },
        confirmarAtender(){
            this.$refs.formAtender.validate((valid) => { if(valid){
                document.getElementById('btn-atender').focus();
                window.eventBus.$emit('loading', true);
                this.$axios.post(
                    `${this.$store.state.config.baseUrlApi}/api/biblioteca/reserva/atender/` + this.reservaSelected.id,
                    this.formAtender,
                    this.$store.getters.getHeaderAuth
                ).then((response) => {
                    window.eventBus.$emit('loading', false);
                    if(response.data && response.data.erro){
                        const msg = typeof response.data.erro === 'string' ? response.data.erro : (response.data.erro.text || 'Não foi possível atender a reserva.');
                        window.eventBus.$emit('alert', {msg, type: 'warning'});
                        return;
                    }
                    window.eventBus.$emit('alert', {msg: 'Reserva atendida e empréstimo registrado.', type: 'success'});
                    this.dialogAtenderVisible = false;
                    this.loading();
                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });
            }});
        },
        formatData(d){
            if(!d) return '-';
            return this.$moment(d).format('DD/MM/YYYY');
        },
        resetFiltro(){
            this.filtro = {
                usuario_tipo: '',
                usuario_id: '',
                status: '',
                instituicao_id: '',
                instituicao: this.$store.state.config.instituicao
                    ? { id: this.$store.state.config.instituicao.id, nome: this.$store.state.config.instituicao.nome }
                    : { id: '', nome: '' }
            };
            this.paginate.page = 1;
            this.loading();
        },
        getPagePagination(page){
            this.paginate.page = page;
            this.loading();
        }
    }
}
</script>
